import { createContext, useContext, useState } from "react";

const GlobalContext = createContext();
export const useGlobalContext = () => useContext(GlobalContext);

const getInitialConfig = () => ({
  baseUrl: process.env.REACT_APP_BASE_URL,
  urlCobranzas: process.env.REACT_APP_COBRANZAS_URL,
  urlDocumentos: process.env.REACT_APP_DOCUMENTOS_URL,
  urlContactos: process.env.REACT_APP_CONTACTOS_URL,
});

const AppContext = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const initialConfig = getInitialConfig();
  const [baseUrl, setBaseUrl] = useState(initialConfig.baseUrl);
  const [urlCobranzas, setUrlCobranzas] = useState(initialConfig.urlCobranzas);
  const [urlDocumentos, setUrlDocumentos] = useState(
    initialConfig.urlDocumentos,
  );
  const [urlContactos, setUrlContactos] = useState(initialConfig.urlContactos);
  const [isRecuperar, setIsRecuperar] = useState(false);

  const [usuario, setUsuario] = useState();

  const headerText = new Headers();

  headerText.append("Content-Type", "application/json;charset=UTF-8");

  // backgroundColor: "#007ad9"
  const [styleProperties, setStyleProperties] = useState({
    logo: "assets/layout/images/Recurso-2.png",
    title: "Medidores",
    backgroundColor: "lightblue",
    button: {
      backgroundColor: "#20ba84",
      foreColor: "#fff",
      border: "1px solid #007ad9",
    },
  });

  return (
    <GlobalContext.Provider
      value={{
        baseUrl,
        setBaseUrl,
        urlCobranzas,
        setUrlCobranzas,
        urlContactos,
        setUrlContactos,
        urlDocumentos,
        setUrlDocumentos,
        styleProperties,
        setStyleProperties,
        isLoggedIn,
        setIsLoggedIn,
        usuario,
        setUsuario,
        isRecuperar,
        setIsRecuperar,
        headerText,
      }}
    >
      {children}
    </GlobalContext.Provider>
  );
};

export default AppContext;
